import { Divider, Button, Input, Modal } from "antd";
import React, { Suspense, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import MyInput from "../components/Input";
import MyButton from "../components/Button";
import Typography from "../components/Typography";
import { COLORS } from "../constants/Colors";
import useIsDesktop from "../utils/hooks/useIsDesktop";
import { FormattedMessage } from "react-intl";

const PrivacyPolicyModal = (props) => {
  const { isOpen, onCancle, onAcceptPolicy } = props;
  // const navigate = useNavigate();
  const [isEnableAcceptBtn, setEnableAcceptBtn] = useState(false);
  const [bottom, setBottom] = useState(true);
  const [scrollTop, setScrollTop] = useState(0);

  const isDesktop = useIsDesktop();

  // const ref = useRef();

  // useEffect(() => {
  //   const handleScroll = (e) => {
  //     // Do your stuff here
  //     //console.log("e", e);
  //     const bottom =
  //       e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
  //     //console.log("bottom", bottom);
  //     setBottom(bottom);
  //   };

  //   ref.current?.addEventListener("scroll", handleScroll);
  //   return () => ref.current?.removeEventListener("scroll", handleScroll);
  // }, []);

  // const handleScroll = (e) => {
  //   //console.log("e", e);
  //   // const bottom =
  //   //   e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
  //   // //console.log("bottom", bottom);
  //   // setBottom(bottom);
  //   setScrollTop(e.currentTarget.scrollTop);
  //   //console.log("e", e.currentTarget.scrollTop);
  // };

  const handleAccept = () => {
    onAcceptPolicy();
    onCancle();
  };

  return (
    <Modal
      title={
        <Typography
          color={COLORS.Primary}
          isBold
          size={isDesktop ? "40px" : "18px"}
          lineHeight={isDesktop ? "60px" : "14px"}
          className="pb-3 text-center"
        >
          <FormattedMessage id='labelPrivacyPolicy' defaultMessage='Privacy Policy' />
        </Typography>
      }
      open={isOpen}
      onOk={() => {}}
      onCancel={onCancle}
      width={680}
      footer={[
        <MyButton
          // className="w-25"
          style={{
            width: isDesktop ? "25%" : "48%",
          }}
          onClick={onCancle}
        >
          <FormattedMessage id='btnCancel' defaultMessage='Cancel' />
        </MyButton>,
        <MyButton
          isPrimary
          onClick={handleAccept}
          disabled={isEnableAcceptBtn}
          // className="w-25"
          style={{
            width: isDesktop ? "25%" : "48%",
          }}
        >
          <FormattedMessage id='btnAccept' defaultMessage='Accept' />
        </MyButton>,
      ]}
    >
      <Divider className="m-0" />

      <div className="d-flex flex-column px-4">
        <Typography
          // fontType="heading"
          size="20px"
          lineHeight="24px"
          className="pt-4"
          isBold
          color={COLORS.Dark}
        >
          ประกาศความเป็นส่วนตัวสําหรับลูกค้า
        </Typography>
        <Typography lineHeight="18px" className="pt-4">
          บริษัท แอกริเกต จำกัด ให้ความสําคัญกับความเป็นส่วนตัว
          และมุ่งมั่นที่จะคุ้มครองข้อมูลส่วนบุคคลของท่าน (“ข้อมูลส่วนบุคคล”) ตาม
          กฎหมายไทย ประกาศความเป็นส่วนตัวฉบับนี้อธิบายถึงรายละเอียดดังต่อไปนี้
        </Typography>
        <div className="row">
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              ข้อมูลส่วนบุคคลประเภทใดบ้างที่บริษัทฯ เก็บรวบรวม
              โดยที่ข้อมูลดังกล่าวรวมถึงข้อมูลที่ท่านมอบให้แก่บริษัทฯ
              เกี่ยวกับตัวท่านเอง หรือบุคคลที่มีความเกี่ยวข้องกับธุรกิจของท่าน
              (“ท่าน”) และข้อมูลที่บริษัทฯ รับทราบจากการ
              ที่ท่านเป็นลูกค้าของบริษัทฯ
              และข้อมูลทางการตลาดที่ท่านประสงค์ที่จะให้บริษัทฯ ส่งให้แก่ท่าน{" "}
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-1%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              บริษัทฯ ใช้ข้อมูลส่วนบุคคลของท่านอย่างไร
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              บริษัทฯ เปิดเผยข้อมูลส่วนบุคคลของท่านแก่บุคคลใดบ้าง
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              ทางเลือกที่บริษัทฯ นําเสนอให้แก่ท่าน
              รวมถึงวิธีการเข้าถึงและดําเนินการให้ข้อมูลส่วนบุคคลของท่านเป็นปัจจุบัน
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-1%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              สิทธิที่ท่านมีต่อข้อมูลส่วนบุคคลของท่านได้แก่อะไรบ้าง
              และกฎหมายนั้นปกป้องคุ้มครองท่านอย่างไร
            </Typography>
          </div>
        </div>

        <Typography
          size="20px"
          lineHeight="24px"
          isBold
          color={COLORS.Dark}
          className="pt-5"
        >
          1. การเก็บรวบรวมข้อมูลส่วนบุคคล
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          บริษัทฯ เก็บรวบรวมข้อมูลส่วนบุคคลหลากหลายประเภท
          โดยประเภทของข้อมูลส่วนบุคคลที่บริษัทฯ
          เก็บรวบรวมนั้นขึ้นอยู่กับสถานการณ์ และลักษณะของสินค้า บริการ และ/หรือ
          ธุรกรรม ซึ่งแตกต่างกันออกไปในแต่ละประเภท บริษัทฯ
          เก็บรวบรวมข้อมูลส่วนบุคคลของท่านจากแหล่งข้อมูลที่หลากหลายดังต่อไปนี้
          (แต่ไม่จํากัดเพียง)
        </Typography>
        <div className="row">
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              เมื่อท่านซื้อสินค้า และ/หรือ ขอรับบริการจากบริษัทฯ
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              การสนทนาระหว่างท่าน และบริษัทฯ รวมถึงบันทึกการสนทนาผ่านทางโทรศัพท์
              จดหมาย อีเมล บันทึกข้อความ หรือวิธีการอื่นใด
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              เมื่อท่านใช้งานเว็บไซต์ของบริษัทฯ หรือแอปพลิเคชันบนโทรศัพท์มือถือ
              รวมถึงการใช้คุกกี้และโปรแกรม tracking อื่น ๆ
              ในการเก็บรวบรวมข้อมูลส่วนบุคคล
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              ข้อมูลที่ได้รับจากเอกสารประกันภัย หรือเอกสารอื่น ๆ
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              เมื่อท่านเข้าร่วมในการแข่งขัน หรือการส่งเสริมการตลาดของบริษัทฯ
            </Typography>
          </div>
        </div>
        <Typography lineHeight="18px" className="pb-3">
          ในบางกรณี บริษัทฯ
          อาจร่วมกับบุคคลภายนอกซึ่งไม่ใช่บริษัทในเครือของบริษัทฯ
          เก็บรวบรวมข้อมูลส่วนบุคคลของ
          ท่านที่เกี่ยวกับกิจกรรมออนไลน์เมื่อท่านเข้าเยี่ยมชมแหล่งข้อมูลออนไลน์ของบริษัทฯ
          นอกจากนี้ บริษัทฯ อาจใช้ข้อมูลส่วน
          บุคคลของท่านซึ่งเก็บรวบรวมผ่านทางเว็บไซต์อื่นๆ
          ที่ไม่ได้อยู่ในเครือข่ายของบริษัทฯ เพื่อวัตถุประสงค์ในการโฆษณาซึ่ง
          วิเคราะห์แล้วว่าตรงกับพฤติกรรมการใช้งานเว็บไซต์ของท่านอีกด้วย
          อย่างไรก็ตาม บริษัทฯ จะแจ้ง
          และเปิดโอกาสให้ท่านปฏิเสธการประมวลผลข้อมูลเช่นว่านั้นได้
        </Typography>
        <Typography lineHeight="18px" className="">
          ประเภทของข้อมูลส่วนบุคคลที่บริษัทฯ
          ประมวลผลภายใต้กฎหมายที่เกี่ยวข้องมีดังต่อไปนี้ (แต่ไม่จํากัดเพียง)
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          - ข้อมูลส่วนตัว : ชื่อ นามสกุล เพศ วันเกิด อายุ สถานภาพการสมรส
          หมายเลขบัตรประชาชน หมายเลขหนังสือเดินทาง หมายเลขประกันสังคม
          ข้อมูลการติดต่อ (เช่น อีเมล เบอร์โทรศัพท์ Social Media เป็นต้น)
          สัญชาติ รูปภาพหนังสือเดินทาง ใบขับขี่ ลายมือชื่อ ภาพถ่าย
          และรูปภาพจากกล้องโทรทัศน์วงจรปิด (CCTV)
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          - ข้อมูลทางการเงิน : ข้อมูลบัญชีธนาคาร ที่อยู่เรียกเก็บเงิน
          เลขที่บัตรเครดิต และชื่อผู้ถือบัตร และรายละเอียดของบัตรเครดิต
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          - ข้อมูลครอบครัว : ชื่อ และข้อมูลการติดต่อของสมาชิกในครอบครัว
          รวมทั้งคู่สมรสและบุตร
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          - ข้อมูลการติดต่อ : ที่อยู่ เบอร์โทรศัพท์ เบอร์โทรศัพท์มือถือ อีเมล
          และรายละเอียด Social Media
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          - บันทึกข้อมูลของลูกค้า และรายละเอียดการทําธุรกรรม :
          ข้อมูลการซื้อสินค้า และบริการของบริษัทฯ หรือ การใช้งาน ข้อมูลธุรกรรม
          ประวัติการทําธุรกรรม (อาทิ หมายเลขการทําธุรกรรม
          จํานวนเงินในการทําธุรกรรม วันที่ และ สถานที่ที่มีการ ทําธุรกรรม
          เวลาที่มีการทําธุรกรรม รายละเอียดการชําระเงิน)
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          - ข้อมูลอิเล็กทรอนิกส์ : ที่อยู่ IP คุกกี้ บันทึกกิจกรรม
          ข้อมูลระบุตัวตน ตัวระบุออนไลน์ ค่าเอกลักษณ์ประจําอุปกรณ์ (unique
          device identifiers) และข้อมูลตําแหน่งทางภูมิศาสตร์
        </Typography>

        <Typography
          size="20px"
          lineHeight="24px"
          isBold
          color={COLORS.Dark}
          className="pt-5"
        >
          2. การใช้ข้อมูลส่วนบุคคล
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          บริษัทฯ อาจเก็บรวบรวม
          และใช้ข้อมูลส่วนบุคคลของท่านเฉพาะในกรณีที่บริษัทฯ
          มีเหตุผลเหมาะสมในการดำเนินการเช่าว่านั้น ทั้งนี้
          รวมถึงการเปิดเผยข้อมูลส่วนบุคคลให้กับบุคคลภายนอก บริษัทฯ
          จะอาศัยฐานใดฐานหนึ่งดังต่อไปนี้ หรือมากกว่า
          ในการประมวลผลข้อมูลส่วนบุคคล
        </Typography>
        <div className="row">
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              เมื่อเป็นการปฏิบัติตามข้อตกลงในสัญญาที่บริษัทฯ ทำไว้กับท่าน
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              เมื่อเป็นหน้าที่ตามกฎหมายของบริษัทฯ
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              เมื่อเป็นผลประโยชน์อันชอบธรรมของบริษัทฯ และ/หรือ
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              เมื่อท่านให้ความยินยอม
            </Typography>
          </div>
        </div>
        <Typography lineHeight="18px" className="pb-3">
          วัตถุประสงค์ในการประมวลผลข้อมูลส่วนบุคคลของท่านดังต่อไปนี้นั้น
          เป็นไปตามกฎหมาย และฐานทางกฎหมาย ที่บริษัทฯ อาจเลือกใช้
        </Typography>
        <div
          className="row pt-3"
          style={{
            marginTop: "",
          }}
        >
          <div
            className="col-8"
            style={{
              color: COLORS.LightGray,
              textAlign: "center",
              border: "1px solid",
            }}
          >
            <Typography lineHeight="18px" className="pt-3 pb-3">
              วัตถุประสงค์ในการประมวลผลข้อมูลส่วนบุคคล
            </Typography>
          </div>
          <div
            className="col-4"
            style={{
              color: COLORS.LightGray,
              textAlign: "center",
              border: "1px solid",
              borderLeft: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3 pb-3">
              ฐานทางกฎหมาย
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "",
          }}
        >
          <div
            className="col-8"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3 pb-3">
              1. เพื่อนํามาพัฒนาการให้บริการในด้านต่างๆ เช่น การจัดส่งพัสดุและ
              ผลิตภัณฑ์ต่างๆ การให้ความช่วยเหลือ และการดําเนินการตามข้อ
              ร้องเรียนของท่านให้มีประสิทธิภาพยิ่งขึ้น และเพื่อการสํารวจและศึกษา
              ความต้องการของท่าน เพื่อจัดโปรแกรมส่งเสริมการขายหรือโปรโมชั่นต่างๆ
              ให้ตอบโจทย์ความต้องการของท่าน
            </Typography>
          </div>
          <div
            className="col-4"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
              borderLeft: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3">
              <span style={{ color: COLORS.Primary }}>● </span>ความยินยอมของท่าน
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "",
          }}
        >
          <div
            className="col-8"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3 pb-3">
              2. เพื่อนํามาพัฒนาช่องทางการให้บริการออนไลน์ของบริษัทฯ
              เพื่อให้ท่าน ได้รับบริการจากบริษัทฯ อย่างมีคุณภาพ
              รวดเร็วและสะดวกสบายที่สุด
            </Typography>
          </div>
          <div
            className="col-4"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
              borderLeft: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3">
              <span style={{ color: COLORS.Primary }}>● </span>
              ประโยชน์อันชอบธรรม
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "",
          }}
        >
          <div
            className="col-8"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3 pb-3">
              3. เพื่อให้ท่านสามารถเข้าใช้งานหรือถ่ายโอนข้อมูลในบัญชี
              เลขที่สมาชิก หรือรหัสส่วนตัวต่างๆ ที่บริษัทฯ ได้ให้บริการต่อท่าน
              ผ่านเครื่อง คอมพิวเตอร์และ/หรืออุปกรณ์อิเล็กทรอนิกส์อื่นๆ
              ได้มากกว่า 1 เครื่อง และเพื่อให้บริษัทฯ
              สามารถดูแลตรวจสอบการเข้าใช้งานบัญชี เลขที่ สมาชิก
              หรือรหัสส่วนตัวต่างๆ ของท่านได้อย่างมีประสิทธิภาพ เพื่อป้องกัน
              ไม่ให้เกิดการใช้งานโดยไม่ได้รับอนุญาต
              หรือการเข้าใช้งานโดยบุคคลอื่น หรือการใช้งานโดยฉ้อฉลหรือในทางมิชอบ
              รวมถึงเพื่อปรับปรุงการ ให้บริการของ บริษัทฯ
              ให้มีความเหมาะสมและมีประสิทธิภาพมากยิ่งขึ้น
            </Typography>
          </div>
          <div
            className="col-4"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
              borderLeft: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3">
              <span style={{ color: COLORS.Primary }}>● </span>
              การปฏิบัติตามสัญญา
            </Typography>
            <Typography lineHeight="18px" className="pt-2">
              <span style={{ color: COLORS.Primary }}>● </span>
              ประโยชน์อันชอบธรรม
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "",
          }}
        >
          <div
            className="col-8"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3 pb-3">
              4. เพื่อนําเสนอข่าวสารที่น่าสนใจและอาจเป็นประโยชน์ต่อท่าน รวมถึง
              การนําเสนอกิจกรรมส่งเสริมการขายหรือโปรโมชั่นต่างๆ ที่จะช่วยให้ท่าน
              ได้รับการบริการและสิทธิประโยชน์ที่ดีที่สุดจากบริษัทฯ บริษัทย่อย
              บริษัท ภายในเครือ และ/หรือ พันธมิตรทางธุรกิจ
            </Typography>
          </div>
          <div
            className="col-4"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
              borderLeft: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3">
              <span style={{ color: COLORS.Primary }}>● </span>
              ประโยชน์อันชอบธรรม
            </Typography>
            <Typography lineHeight="18px" className="pt-2">
              <span style={{ color: COLORS.Primary }}>● </span>ความยินยอมของท่าน
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "",
          }}
        >
          <div
            className="col-8"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3 pb-3">
              5. เพื่อวัตถุประสงค์ในทางการตลาดและการส่งเสริมการขาย การวิเคราะห์
              ข้อมูล การตลาดดิจิตอล โปรแกรมสมาชิก และ/หรือ โปรแกรมการให้ รางวัล
              และ ข้อมูลที่เกี่ยวข้องการสินค้าและบริการของ บริษัทฯ รวมถึง
              การมีส่วนร่วมของท่านในกิจกรรมต่างๆ ที่บริษัทฯ ได้จัดขึ้น
              เพื่อให้ท่าน ได้รับสิทธิประโยชน์ในการใช้บริการมากที่สุด
              โดยตั้งอยู่บนความพึงพอใจของท่านเป็นสําคัญ
              โดยท่านสามารถแจ้งความประสงค์ของท่านต่อการใช้ข้อมูลของท่านเพื่อวัตถุประสงค์ในทางการตลาดที่กล่าวมาของ
              บริษัทฯ ได้ ผ่านช่องทางที่บริษัทฯ บริษัทย่อย บริษัทในเครือ
              และ/หรือ พันธมิตรทาง ธุรกิจได้กําหนดไว้
            </Typography>
          </div>
          <div
            className="col-4"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
              borderLeft: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3">
              <span style={{ color: COLORS.Primary }}>● </span>ความยินยอมของท่าน
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "",
          }}
        >
          <div
            className="col-8"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3 pb-3">
              6. เพื่อให้ท่านมีส่วนร่วมในโปรแกรมสมาชิก และ/หรือ โปรแกรมการให้
              รางวัล และ กิจกรรมที่เกี่ยวข้อง และการสื่อสาร
              ที่ดําเนินการโดยบริษัทฯ บริษัทย่อย บริษัทในเครื่อ และ/หรือ
              พันธมิตรทางธุรกิจได้กําหนดไว้
            </Typography>
          </div>
          <div
            className="col-4"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
              borderLeft: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3">
              <span style={{ color: COLORS.Primary }}>● </span>ความยินยอมของท่าน
            </Typography>
            <Typography lineHeight="18px" className="pt-2">
              <span style={{ color: COLORS.Primary }}>● </span>
              การปฏิบัติตามสัญญา
            </Typography>
            <Typography lineHeight="18px" className="pt-2">
              <span style={{ color: COLORS.Primary }}>● </span>
              ประโยชน์อันชอบธรรม
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "",
          }}
        >
          <div
            className="col-8"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3 pb-3">
              7. เพื่อวัดประสิทธิภาพของนโยบายทางการตลาดของบริษัทฯ
              และเพื่อวัดประสิทธิผลของการโฆษณาของบริษัทฯ
              ผ่านช่องทางสื่อออนไลน์ต่างๆ
            </Typography>
          </div>
          <div
            className="col-4"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
              borderLeft: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3">
              <span style={{ color: COLORS.Primary }}>● </span>ความยินยอมของท่าน
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "",
          }}
        >
          <div
            className="col-8"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3 pb-3">
              8. เพื่อระงับข้อพิพาทหรือข้อขัดแย้งที่อาจเกิดขึ้น ระหว่างบริษัทฯ
              กับท่านอันเกี่ยวข้องกับการให้บริการของบริษัทฯ
            </Typography>
          </div>
          <div
            className="col-4"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
              borderLeft: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3">
              <span style={{ color: COLORS.Primary }}>● </span>
              การปฏิบัติตามสัญญา
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "",
          }}
        >
          <div
            className="col-8"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3 pb-3">
              9. เพื่อวัตถุประสงค์อันชอบด้วยกฎหมายและเท่าที่จําเป็นเท่านั้น
              เพื่อให้ บรรลุวัตถุประสงค์ในการให้บริการของบริษัทฯ
              แก่ท่านในฐานะเจ้าของข้อมูล
              รวมถึงเพื่อวัตถุประสงค์ในการปฏิบัติตามกฎหมายและกฎระเบียบใดๆ
            </Typography>
          </div>
          <div
            className="col-4"
            style={{
              color: COLORS.LightGray,
              border: "1px solid",
              borderTop: "0px",
              borderLeft: "0px",
            }}
          >
            <Typography lineHeight="18px" className="pt-3">
              <span style={{ color: COLORS.Primary }}>● </span>
              การปฏิบัติตามสัญญา
            </Typography>
            <Typography lineHeight="18px" className="pt-2">
              <span style={{ color: COLORS.Primary }}>● </span>หน้าที่ตามกฎหมาย
            </Typography>
          </div>
        </div>
        <Typography lineHeight="18px" className="pt-3">
          ในกรณีที่บริษัทฯ อาศัยฐานผลประโยชน์อันชอบธรรมของบริษัทฯ
          ในการประมวลผลข้อมูลส่วนบุคคล บริษัทฯ จะ พิจารณาว่า
          ประโยชน์ดังกล่าวของบริษัทฯ นั้น มีความสําคัญยิ่งกว่าสิทธิของท่าน
          หรือไม่ และจะต้องสามารถสรุปได้ว่า
          ประโยชน์ดังกล่าวมีความสําคัญยิ่งกว่าสิทธิของท่าน
        </Typography>

        <Typography
          size="20px"
          lineHeight="24px"
          isBold
          color={COLORS.Dark}
          className="pt-5"
        >
          3. การเปิดเผยข้อมูลส่วนบุคคล
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          บริษัทฯ
          อาจเปิดเผยข้อมูลส่วนบุคคลของท่านให้กับบุคคลอื่นในกรณีที่สามารถทําได้ตามกฎหมาย
          รวมถึงกรณี ดังต่อไปนี้ที่บริษัทฯ หรือบุคคลอื่นดังกล่าว
        </Typography>
        <div className="row">
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              จําเป็นต้องปฏิบัติตามข้อกําหนดของสัญญา
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              มีหน้าที่ตามกฎหมายในการกระทําการดังกล่าว (เช่น เพื่อสืบหา
              และป้องกันการทุจริต การหนีภาษี อาชญากรรม ทางการเงิน เป็นต้น)
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              จําเป็นต้องรายงานตามกฎหมาย ดําเนินคดี ใช้สิทธิตามกฎหมาย
              หรือปกป้องสิทธิเรียกร้องตามกฎหมาย
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              กระทําไปเพื่อประโยชน์ของธุรกิจโดยชอบด้วยกฎหมาย (เช่น
              เพื่อบริหารความเสี่ยง เพื่อยืนยันตัวตน เพื่อให้บริษัท
              อื่นสามารถให้บริการตามที่ท่านร้องขอได้
              เพื่อประเมินความเหมาะสมของท่านต่อสินค้า และ/หรือบริการ เพื่อจัดทํา
              รายงานภายใน / การวิเคราะห์ข้อมูล / การบริหารจัดการการปฏิบัติงาน
              เป็นต้น) และ/หรือ
            </Typography>
          </div>
        </div>
        <div className="row">
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              ขอความยินยอมจากท่านในการเปิดเผยข้อมูลดังกล่าว และท่านให้ความยินยอม
            </Typography>
          </div>
        </div>
        {/* <Typography lineHeight="18px" className="pt-3 pb-3">
          บริษัทฯ
          อาจเปิดเผยข้อมูลส่วนบุคคลของท่านให้กับบุคคลอื่นเพื่อวัตถุประสงค์ดังต่อไปนี้
        </Typography> */}
        <div
          className="row"
          style={{
            marginTop: "",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              บริษัทย่อย บริษัทในเครือ และบริษัทอื่นๆภายในกลุ่ม
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              กลุ่มบริษัทอื่นๆ ผู้รับเหมาช่วง นายหน้า หรือผู้ให้บริการใดๆ
              ที่ทํางานให้กับบริษัทฯ หรือให้บริการแก่บริษัทฯ ทั้งนี้
              รวมถึงผู้รับเหมาช่วง ผู้ให้บริการ ผู้บังคับบัญชา
              และผู้ปฏิบัติงานของบุคคลดังกล่าว
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              ผู้ได้รับมอบหมายให้จัดการดูแลผลประโยชน์ใดๆ ของท่าน
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              บุคคลใดๆ ที่ท่านชําระเงินให้ และ/หรือ ได้รับชําระเงิน
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              สถาบันทางการเงิน และผู้ให้บริการรับชําระเงิน
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              บุคคล หรือบริษัทใดๆ ซึ่งเกี่ยวข้องกับการปรับโครงสร้างบริษัท
              การควบรวม หรือเข้าถือครองกิจการที่เกิดขึ้นหรือ อาจเกิดขึ้น
              โดยรวมถึงการโอนสิทธิ หรือหน้าที่ใดๆ ซึ่งบริษัทฯ
              มีอยู่ภายใต้สัญญาระหว่างบริษัทฯ และท่าน
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              หน่วยงานที่บังคับใช้กฎหมาย รัฐบาล ศาล หน่วยงานระงับข้อพิพาท
              ผู้กํากับดูแลบริษัทฯ ผู้ตรวจสอบบัญชี และ บุคคลใดๆ ซึ่งแต่งตั้ง
              หรือร้องขอโดยผู้กํากับดูแลบริษัทฯให้ทําการตรวจสอบกิจกรรมการดําเนินงานของบริษัทฯ
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              บุคคลอื่นใดซึ่งมีความเกี่ยวข้องกับข้อพิพาทใดๆ ที่เกิดขึ้น
              รวมถึงข้อพิพาทที่เกี่ยวข้องกับการทําธุรกรรม
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              หน่วยงานป้องกันการทุจริตซึ่งใช้ข้อมูลดังกล่าวเพื่อสืบหา
              และป้องกันการทุจริต
              และอาชญากรรมทางการเงินอื่นๆและเพื่อยืนยันตัวตนของท่าน
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              บุคคลใดๆ ที่ออกคําสั่ง หรือบริหารจัดการ สินค้า
              หรือบริการในนามของท่าน (เช่น ผู้รับมอบอํานาจ ทนายความ คน กลาง
              เป็นต้น)
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              บุคคลใดๆ ที่บริษัทฯ
              ได้รับคําสั่งจากท่านให้เปิดเผยข้อมูลส่วนบุคคลของท่านให้กับบุคคลดังกล่าว
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              บุคคลอื่นที่เป็นคู่ค้าหรือพันธมิตรทางธุรกิจของบริษัทฯ
              รวมถึงบริษัทย่อย และ บริษัทภายในเครือ
            </Typography>
          </div>
        </div>
        <Typography lineHeight="18px" className="">
          เมื่อบริษัทฯได้เปิดเผยข้อมูลส่วนบุคคลส่วนบุคคลของท่านไปยังบุคคลที่สาม
          ท่านจะได้รับการคุ้มครองโดยนโยบาย ความเป็นส่วนตัวของบุคคลที่สาม
          ซึ่งทําหน้าที่เป็นผู้ควบคุมข้อมูลส่วนบุคคลสําหรับข้อมูลส่วนบุคคลของท่าน
          บริษัทฯ แนะนํา ให้ท่านอ่านรายละเอียดนโยบายความเป็นส่วนตัว
          เพื่อรับทราบว่าบุคคลที่สามดําเนินการเก็บรวบรวม ใช้ และ เปิดเผยข้อมูล
          ส่วนบุคคลของท่านอย่างไร
          ในกรณีที่ท่านต้องการใช้สิทธิในข้อมูลส่วนบุคคลที่ดูแลโดยบุคคลที่สาม
          กรุณาติดต่อตามช่องทางที่ บุคคลที่สามได้แจ้งไว้โดยตรง
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          บริษัทฯ
          จะไม่ใช้ข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์อื่นใดนอกเหนือจากที่ได้แจ้งแก่ท่านในประกาศความเป็น
          ส่วนตัวนี้ หากบริษัทฯ ประสงค์ที่จะเก็บรวบรวม ใช้ ส่ง
          หรือโอนข้อมูลส่วนบุคคลของท่านเพิ่มเติม ซึ่งไม่ได้ระบุในประกาศ
          ความเป็นส่วนตัวนี้ บริษัทฯ จะแจ้ง
          และขอความยินยอมจากท่านก่อนการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลดังกล่าว
          โดยที่ท่านมีสิทธิจะให้ความยินยอม หรือไม่ก็ได้
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          บริษัทฯ
          จะปฏิบัติตามประกาศความเป็นส่วนตัวนี้อย่างเคร่งครัดต่อข้อมูลที่อยู่ในความครอบครองของบริษัทฯ
          ซึ่ง เกี่ยวข้องกับลูกค้าและนักลงทุนในอนาคต ปัจจุบันและในอดีต
        </Typography>
        <Typography
          lineHeight="18px"
          className="pt-3 pb-2"
          color={COLORS.Primary}
        >
          การส่ง หรือโอนข้อมูลไปยังต่างประเทศ
        </Typography>
        <Typography lineHeight="18px" className="">
          ข้อมูลส่วนบุคคลของท่านอาจถูกโอนไปยังต่างประเทศ
          และถูกเก็บ/ประมวลผลในต่างประเทศทั้งนี้ ประเทศเช่นว่า
          นั้นอาจไม่มีมาตรการคุ้มครองข้อมูลส่วนบุคคลในระดับที่เทียบเท่ากับประเทศไทย
          ในกรณีที่บริษัทฯ จะกระทําการดังกล่าว บริษัทฯ รับรองว่า ประเทศดังกล่าว
          มีมาตรการคุ้มครองข้อมูลส่วนบุคคลในระดับที่เหมาะสม และการส่ง
          หรือโอนข้อมูล ดังกล่าวชอบด้วยกฎหมาย บริษัทฯ อาจต้องส่ง
          หรือโอนข้อมูลส่วนบุคคลเพื่อการปฏิบัติตามสัญญาที่ทําขึ้นระหว่างท่าน และ
          บริษัทฯ เพื่อปฏิบัติตามข้อกําหนดทางกฎหมาย
          ปกป้องคุ้มครองประโยชน์สาธารณะ และ/หรือ เพื่อผลประโยชน์อันชอบธรรม
          ของบริษัทฯ อย่างไรก็ตาม กฎหมายของบางประเทศอาจกําหนดให้บริษัทฯ
          ต้องเปิดเผยข้อมูลส่วนบุคคลบางประเภท (เช่น
          เปิดเผยให้กับหน่วยงานทางภาษี) ในกรณีเช่นว่านั้น บริษัทฯ
          จะเปิดเผยข้อมูลส่วนบุคคลให้กับบุคคลที่มีสิทธิเห็น หรือเข้าถึง
          ข้อมูลดังกล่าวเท่านั้น
        </Typography>

        <Typography
          size="20px"
          lineHeight="24px"
          isBold
          color={COLORS.Dark}
          className="pt-5"
        >
          4. การเก็บรักษาข้อมูลส่วนบุคคลของท่าน
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          บริษัทฯ
          จะเก็บรวบรวมข้อมูลส่วนบุคคลของท่านไว้ตราบเท่าที่จําเป็นเพื่อให้บรรลุวัตถุประสงค์ในการเก็บรวบรวม
          ข้อมูลดังกล่าว กล่าวคือ เพื่อเหตุผลทางธุรกิจ และ/หรือ
          เพื่อปฏิบัติตามกฎหมายที่เกี่ยวข้อง
        </Typography>
        <Typography
          isBold
          lineHeight="18px"
          className="pt-3"
          style={{ textDecoration: "underline" }}
        >
          บริษัทฯ จะเก็บรักษาข้อมูลส่วนบุคคลของท่านไว้เป็นเวลา 10 ปี
          ภายหลังจากที่ท่านไม่ได้เป็นลูกค้าของบริษัทฯ แล้ว ทั้งนี้
          เพื่อประโยชน์ของบริษัทฯ ในการดําเนินข้อพิพาททางสัญญาใดๆ
          ที่อาจเกิดขึ้นนั้นในระยะเวลาดังกล่าว
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          เว้นแต่กรณีที่มีเหตุผลทางกฎหมาย หรือเหตุผลทางเทคนิครองรับ บริษัทฯ
          อาจเก็บรักษาข้อมูลส่วนบุคคลของท่าน ไว้นานกว่า 10 ปีได้ หากบริษัทฯ
          ไม่มีความจําเป็นที่จะต้องเก็บรักษาข้อมูลของท่านแล้ว บริษัทฯ จะทําลาย
          ลบ
          หรือทําให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูลส่วนบุคคลได้
        </Typography>

        <Typography
          size="20px"
          lineHeight="24px"
          isBold
          color={COLORS.Dark}
          className="pt-5"
        >
          5. ความถูกต้องของข้อมูลส่วนบุคคลของท่าน
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          ท่านจะต้องทําให้ข้อมูลส่วนบุคคลของท่านที่อยู่ในความครอบครองของบริษัทฯ
          มีความเป็นปัจจุบัน สมบูรณ์ และถูกต้อง โดยจะต้องแจ้งบริษัทฯ
          เมื่อข้อมูลส่วนบุคคลของท่านมีการเปลี่ยนแปลงใดๆ โดย
        </Typography>
        <div className="row">
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              ปรับปรุงแก้ไขข้อมูลส่วนบุคคลของท่านที่/ผ่านทางเว็บไซต์ หรือ
              แอปพลิเคชันของบริษัทฯ
            </Typography>
          </div>
        </div>
        <Typography lineHeight="18px" className="pt-3">
          บริษัทฯ จะขอให้ท่านปรับปรุงแก้ไขข้อมูลให้เป็นปัจจุบันเป็นครั้งคราว
          เพื่อให้ข้อมูลดังกล่าวเป็นข้อมูลที่เป็นปัจจุบันถูกต้องและสมบูรณ์
        </Typography>

        <Typography
          size="20px"
          lineHeight="24px"
          isBold
          color={COLORS.Dark}
          className="pt-5"
        >
          6. สิทธิของท่านในฐานะเจ้าของข้อมูลส่วนบุคคล
        </Typography>
        <div className="row">
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              <span style={{ fontWeight: "bold" }}>
                สิทธิในการขอถอนความยินยอม :{" "}
              </span>
              ท่านมีสิทธิที่จะเพิกถอนความยินยอมที่จะให้บริษัทฯ
              ประมวลผลข้อมูลส่วน บุคคลของท่านได้ตลอดเวลา ทั้งนี้ บริษัทฯ
              อาจประมวลผลข้อมูลส่วนบุคคลของท่านต่อไปหากบริษัทฯ มีฐานอื่นใน
              การประมวลผลข้อมูลส่วนบุคคลของท่าน
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              <span style={{ fontWeight: "bold" }}>
                สิทธิในการขอเข้าถึงข้อมูลส่วนบุคคล :{" "}
              </span>
              ท่านมีสิทธิในการขอสําเนาข้อมูลส่วนบุคคลของท่านจากบริษัทฯ
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              <span style={{ fontWeight: "bold" }}>
                สิทธิในการขอแก้ไขข้อมูลส่วนบุคคล :{" "}
              </span>
              ท่านมีสิทธิขอแก้ไขข้อมูลส่วนบุคคลของท่านให้ถูกต้อง เป็นปัจจุบัน
              และสมบูรณ์
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              <span style={{ fontWeight: "bold" }}>
                สิทธิในการขอลบข้อมูลส่วนบุคคล :{" "}
              </span>
              ท่านมีสิทธิร้องขอให้บริษัทฯ ลบ ทําลาย
              หรือทําให้ข้อมูลส่วนบุคคลของท่านไม่
              สามารถระบุตัวตนของท่านได้ในกรณีที่ไม่มีเหตุผลอันสมควรให้บริษัทฯ
              ประมวลผลข้อมูลส่วนบุคคลของท่านต่อไป ทั้งนี้
              ท่านสามารถใช้สิทธิในการขอให้บริษัทฯ
              ลบข้อมูลส่วนบุคคลนี้ควบคู่ไปกับสิทธิในการคัดค้านในข้อถัดไป
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              <span style={{ fontWeight: "bold" }}>สิทธิในการคัดค้าน : </span>
              ท่านมีสิทธิคัดค้านการประมวลผลข้อมูลส่วนบุคคลของท่านที่บริษัทฯ
              ประมวลผลภายใต้ฐาน ผลประโยชน์อันชอบธรรมของบริษัทฯ นอกจากนี้
              ท่านยังมีสิทธิคัดค้านการประมวลผลข้อมูลส่วนบุคคลของท่าน หากบริษัทฯ
              ประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ทางการตลาด
              และเกี่ยวกับการรวบรวมข้อมูลที่ เป็นประโยชน์ (Profiling)
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              <span style={{ fontWeight: "bold" }}>
                สิทธิในการขอให้มีการจํากัดการประมวลผล :{" "}
              </span>
              ท่านมีสิทธิขอให้บริษัทฯ ระงับการประมวลผลข้อมูลส่วนบุคคลของ
              ท่านชั่วคราว เช่น เมื่อท่านต้องการให้บริษัทฯ
              แก้ไขข้อมูลส่วนบุคคลของท่านให้ถูกต้อง หรือเมื่อท่านร้องขอให้
              บริษัทฯ พิสูจน์เหตุผล
              หรือฐานทางกฎหมายในการประมวลผลข้อมูลส่วนบุคคลของท่าน
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-2">
              <span style={{ fontWeight: "bold" }}>
                สิทธิในการเคลื่อนย้ายข้อมูล :{" "}
              </span>
              ท่านมีสิทธิร้องขอให้บริษัทโอนข้อมูลส่วนบุคคลของท่านไปยังบุคคลอื่น
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3 pb-3">
              <span style={{ fontWeight: "bold" }}>
                สิทธิในการยื่นข้อร้องเรียน :{" "}
              </span>
              ท่านมีสิทธิยื่นข้อร้องเรียนต่อหน่วยงานของรัฐที่เกี่ยวข้อง
              รวมไปถึงคณะกรรมการ คุ้มครองข้อมูลส่วนบุคคล
            </Typography>
          </div>
        </div>
        <Typography lineHeight="18px" className="pb-2" color={COLORS.Primary}>
          การจัดการกับเรื่องร้องเรียน
        </Typography>
        <Typography lineHeight="18px" className="">
          ท่านสามารถติดต่อบริษัทฯ เพื่อร้องเรียนเกี่ยวกับวิธีการที่บริษัทฯ
          ประมวลผลข้อมูลส่วนบุคคลของท่าน และบริษัท ฯ
          จะพิจารณาคําขอของท่านโดยเร็วที่สุด ทั้งนี้
          การเรื่องร้องเรียนต่อบริษัทฯ
          นี้ไม่มีผลกระทบต่อสิทธิของท่านในการร้องเรียน ต่อเจ้าหน้าที่รัฐ
          หรือคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล
        </Typography>

        <Typography
          size="20px"
          lineHeight="24px"
          isBold
          color={COLORS.Dark}
          className="pt-5"
        >
          7. ข้อยกเว้นและข้อจํากัดการให้บริการของบริษัทฯ
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          การเชื่อมโยงเว็บไซต์และบริการอื่นๆ ในกรณีที่เว็บไซต์
          หรือแอปพลิเคชันของบริษัทฯ ได้มีการเชื่อมโยงไปยังเว็บไซต์ ภายนอก
          หรือเว็บไซต์ของบุคคลอื่นๆ ท่านรับทราบว่า บริษัทฯ
          ไม่มีอํานาจในการควบคุม หรือกําหนด หรือตรวจสอบการ ดําเนินงาน
          การให้บริการ นโยบายความเป็นส่วนตัวและการคุ้มครองของข้อมูล
          การใช้หรือประมวลผลข้อมูลของท่านบนหน้า เว็บไซต์นั้นๆ และบริษัทฯ
          จะไม่รับผิดชอบในความเสียหายที่เกิดขึ้นต่อข้อมูลของท่านบนหน้าเว็บไซต์ดังกล่าว
        </Typography>

        <Typography
          size="20px"
          lineHeight="24px"
          isBold
          color={COLORS.Dark}
          className="pt-5"
        >
          8. ข้อยกเว้นและข้อจํากัดการให้บริการของบริษัทฯ
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          ข้อมูลถือเป็นทรัพย์สินของบริษัทฯ ดังนั้น บริษัทฯ
          จึงให้ความสําคัญกับความปลอดภัยของข้อมูลส่วนบุคคลของท่าน เป็นอย่างยิ่ง
          บริษัทฯ จะตรวจสอบ และใช้มาตรการรักษาความปลอดภัยขององค์กร ทั้งทางกายภาพ
          และทางเทคนิคที่ ทันสมัยอยู่เสมอเมื่อประมวลผลข้อมูลส่วนบุคคลของท่าน
          บริษัทฯ ได้วางนโยบาย และมาตรการควบคุมภายในเพื่อให้ท่าน
          มั่นใจว่าข้อมูลส่วนบุคคลของท่านจะไม่สูญหาย ถูกทําลายโดยไม่ตั้งใจ
          ถูกนําไปใช้ในทางที่ผิด ถูกเปิดเผย และเข้าถึงโดยบุคคล
          ทั่วไปที่ไม่ใช่พนักงานที่ปฏิบัติหน้าที่ของบริษัทฯ โดยพนักงานของบริษัทฯ
          นั้นได้รับการอบรม และฝึกฝนให้จัดการกับข้อมูล ส่วนบุคคลอย่างปลอดภัย
          หากพนักงานไม่ปฏิบัติตามที่ได้รับการอบรมฝึกฝนดังกล่าว
          พนักงานจะได้รับโทษทางวินัย
        </Typography>

        <Typography
          size="20px"
          lineHeight="24px"
          isBold
          color={COLORS.Dark}
          className="pt-5"
        >
          9. ข้อยกเว้นและข้อจํากัดการให้บริการของบริษัทฯ
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          ท่านมีหน้าที่ตรวจสอบว่าข้อมูลส่วนบุคคลที่ท่านให้ไว้กับบริษัทฯ
          ไม่ว่าจะด้วยตัวของท่านเอง หรือในนามของท่าน มี ความถูกต้อง
          และเป็นปัจจุบัน และมีหน้าที่ต้องแจ้งให้บริษัทฯ
          ทราบโดยเร็วที่สุดหากข้อมูลดังกล่าวมีการเปลี่ยนแปลงเมื่อท่าน
          เข้าทําสัญญากับบริษัทฯ แล้ว
          ท่านจะมีหน้าที่ตามสัญญาในการส่งมอบข้อมูลส่วนบุคคลให้แก่บริษัทฯ
          เพื่อให้ท่านสามารถใช้ สิทธิทางกฎหมายได้
          การไม่ปฏิบัติตามหน้าที่ดังกล่าวอาจส่งผลให้ท่านสูญเสียสิทธิทางกฎหมาย
          ท่านมีความจําเป็นที่จะต้องส่ง มอบข้อมูลส่วนบุคคล เช่น ข้อมูลการติดต่อ
          และข้อมูลการจ่ายเงินให้กับบริษัทฯ เพื่อให้บริษัทฯ
          สามารถเข้าทําสัญญากับท่าน ได้ หากท่านไม่ส่งมอบข้อมูลส่วนบุคคลดังกล่าว
          อาจทําให้บริษัทฯ ไม่สามารถใช้สิทธิ
          และปฏิบัติตามภาระข้อผูกพันที่เกิดขึ้น จากสัญญาได้อย่างมีประสิทธิภาพ
        </Typography>

        <Typography
          size="20px"
          lineHeight="24px"
          isBold
          color={COLORS.Dark}
          className="pt-5"
        >
          10. การแก้ไขประกาศความเป็นส่วนตัว
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          บริษัทฯ จะตรวจสอบประกาศความเป็นส่วนตัวอย่างสม่ำเสมอ ดังนั้น
          ประกาศความเป็นส่วนตัวนี้จึงอาจมีการแก้ไข เปลี่ยนแปลง
          โดยการแก้ไขเปลี่ยนแปลงครั้งล่าสุดนั้น
          สามารถดูได้จากวันที่ด้านบนของประกาศความเป็นส่วนตัวฉบับนี้
        </Typography>

        <Typography
          size="20px"
          lineHeight="24px"
          isBold
          color={COLORS.Dark}
          className="pt-5"
        >
          11. ช่องทางการติดต่อบริษัทฯ
        </Typography>
        <Typography lineHeight="18px" className="pt-3">
          ในกรณีที่ท่านมีข้อสงสัยเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคลของท่าน
          หรือต้องการใช้สิทธิใดๆ โปรดติดต่อบริษัทฯ
          ที่เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
        </Typography>
        <div className="row">
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              อีเมลหาบริษัทฯ ที่ info@loopthailand.com หรือ
            </Typography>
          </div>
        </div>
        <div
          className="row"
          style={{
            marginTop: "-4%",
          }}
        >
          <div
            className="col-1"
            style={{
              color: COLORS.Primary,
              fontSize: "28px",
            }}
          >
            <label>•</label>
          </div>
          <div className="col-10" style={{ marginLeft: "-4%" }}>
            <Typography lineHeight="18px" className="pt-3">
              โทรหาบริษัทฯ ที่ Call Center 02-000-1199
            </Typography>
          </div>
        </div>

        <br></br>
      </div>
    </Modal>
  );
};

export default PrivacyPolicyModal;
